var exports = {
  "Vg": "ComponentGalleryTabInputsTab.module__grid___UVo2Uj",
  "hK": "ComponentGalleryTabInputsTab.module__gridSingle___UVo2Uj",
  "T_": "ComponentGalleryTabInputsTab.module__inlineEditWrapper___UVo2Uj",
  "qF": "ComponentGalleryTabInputsTab.module__inlineEditLabel___UVo2Uj",
  "WX": "ComponentGalleryTabInputsTab.module__inlineEditCaption___UVo2Uj",
  "V1": "ComponentGalleryTabInputsTab.module__colorPickersGrid___UVo2Uj",
};

module.exports = exports;
